import { render, staticRenderFns } from "./AllPrices.vue?vue&type=template&id=7fd0665d"
import script from "./AllPrices.vue?vue&type=script&lang=js"
export * from "./AllPrices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports